import styles from '../../styles/pdfStyles';
import { Text, View } from '@react-pdf/renderer';
import { formatUTCDate } from '../../utils/converter';

const SummaryPDF = ({ reportData, blockHistory }) => {
  // Format the date based on the earliest blockchain block
  // const formatDate = () => {
  //   const latestBlockDate = getEarliestBlockDate(blockchainHistory);
  //   const formattedDate = latestBlockDate ? timestampToDateAtTime(latestBlockDate) : 'Unknown Date';
  //   return formattedDate;
  // };

  return (
    <View style={styles.boxWrapper}>
      <Text style={styles.h2}>Summary</Text>
      {reportData && +reportData.VALID === 0 ? (
        <Text style={styles.p}>
          No matches were found for this file, and the result is invalid.
        </Text>
      ) : (
        <>
          <Text style={styles.p}>
            On{' '}
            <Text style={styles.strong}>
              {reportData.REQ_ID && blockHistory && blockHistory.length > 0
                ? formatUTCDate(blockHistory[0]?.BLOCK_DATE)
                : formatUTCDate(reportData.BLOCK_DATE)}{' '}
              UTC
            </Text>
            , one or several events were recorded and stamped on the blockchain.
          </Text>

          <Text style={styles.p}>
            All data in this report is sourced from the file named{' '}
            <Text style={styles.strong}>{reportData.FILE_NAME}.</Text>
          </Text>

          <Text style={styles.p}>
            The verification successfully searched for matching hashes and got
            {+reportData.VALID === 0 ? (
              <Text>
                <Text style={styles.strong}>{` an invalid result`}</Text>
                {` with `}
                <Text style={styles.strong}>{`${reportData.VALIDATION_RESULT}`}</Text>.
              </Text>
            ) : (
              +reportData.VALID === 1 && (
                <Text>
                  <Text style={styles.strong}>{` a valid result`}</Text>
                  {` with a `}
                  <Text style={styles.strong}>{`${reportData.VALIDATION_RESULT}`}</Text>.
                </Text>
              )
            )}
          </Text>
        </>
      )}
    </View>
  );
};
export default SummaryPDF;
